// extracted by mini-css-extract-plugin
export default {"products":"ProductList_products__JfCws","top":"ProductList_top__sWE6J","product":"ProductList_product__ZTgRI","item":"ProductList_item__mt7P7","Fade":"ProductList_Fade__D7dKa"};